/* eslint-disable max-classes-per-file */

export class ShopBase {
  determined = false;

  info = null;

  isAuthenticated() {
    return this.determined && this.info && (this.info.id || this.info.pk) || false;
  }
}

export class Shop extends ShopBase {
  constructor(info, determined = true) {
    super();

    this.determined = determined;
    this.info = info || this.info;
  }
}
